import React, { Fragment } from "react";
import * as Styles from "../../../../common-deprecated/styles/v2/toyota/components/Form";
import type { TradeInAemCheckboxType, TradeInAemContactCheckboxIdType } from "../../../utils/constants";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../redux/store";
import PlaceholderUrl from "../../../../common-deprecated/components/PlaceholderUrl";
import { setTradeInAemCheckboxValue } from "../../../redux/actions/TradeInAemContactFormActions";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { IconExclamation } from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { useTradeInAemLabel } from "../../../utils/labels";
import { useDispatch } from "../../../../shared-logic/redux/store";

type Props = { formItemId: TradeInAemContactCheckboxIdType; showRequiredError?: boolean };
const ContactFormCheckbox = ({ formItemId, showRequiredError }: Props): JSX.Element | null => {
    const formItem: TradeInAemCheckboxType | undefined = useTradeInAemSelector(
        (state) => state.tradeInAemContact[formItemId],
    );
    const requiredLabel = useTradeInAemLabel("tradeInAemFieldRequired");
    const dispatch = useDispatch<TradeInAemDispatchType>();

    if (!formItem) return null;

    return (
        <>
            {formItem.items.map(({ label, value, selected, url, required }) => {
                return (
                    <Fragment key={`check-${value}`}>
                        <Styles.Checkbox width={1} mt={0}>
                            <input
                                type="checkbox"
                                id={`check-${value}`}
                                checked={selected}
                                required={required}
                                onChange={() => {
                                    dispatch(setTradeInAemCheckboxValue(formItemId, value, !selected));
                                }}
                            />
                            <label htmlFor={`check-${value}`}>
                                {url ? <PlaceholderUrl url={url} placeholderString={label} tag="link" /> : label}
                                {required && <Styles.MandatoryField>*</Styles.MandatoryField>}
                            </label>
                        </Styles.Checkbox>
                        {showRequiredError && !selected && required && (
                            <Styles.ErrorField>
                                <span>{requiredLabel}</span>
                                <IconWrapper iconColor="primaryRed">
                                    <IconExclamation />
                                </IconWrapper>
                            </Styles.ErrorField>
                        )}
                    </Fragment>
                );
            })}
        </>
    );
};

export default ContactFormCheckbox;
